<template>
  <div
    :class="'CModalContainer | UModalShadow | ' + anchorInfo.class"
    v-on:click="onCancel"
  >
    <div
      class="CProseWithPadding m-pform-fix | UModalAppearance"
      v-on:click.stop
      :style="modalStyle"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { ModalType } from "@/store/ModalType";
import WBComponent from "@/WBComponent";
import Rect from "@/wbcontroller/types/Rect";
import { Component, Prop, Ref } from "vue-property-decorator";
import { CSSProperties } from "vue/types/jsx";

interface AnchorInfo {
  class: string;
  style: Record<string, unknown>;
}

const DEFAULT_ANCHOR_INFO: AnchorInfo = { class: "", style: {} };

@Component
export default class Modal extends WBComponent {
  @Ref() nameField!: HTMLInputElement;
  @Prop({ default: true }) readonly mayCancel!: boolean;
  @Prop({ default: "center" }) readonly verticalAlign!: string;
  @Prop() readonly modalType!: ModalType;
  @Prop({ default: "100%" }) readonly width!: string;
  @Prop({ default: "none" }) readonly anchorStyle!:
    | "none"
    | "leftAuto"
    | "topAuto";

  get modalStyle(): CSSProperties {
    return {
      width: this.width,
      ...this.anchorInfo.style,
    };
  }

  get anchorRect(): Rect | undefined {
    return this.state.modal.modalAnchors[this.modalType];
  }

  get anchorInfo(): AnchorInfo {
    if (!this.anchorRect) {
      if (this.anchorStyle !== "none") debugger;
      return DEFAULT_ANCHOR_INFO;
    }
    switch (this.anchorStyle) {
      case "leftAuto":
        if (this.anchorRect.minY < document.body.clientHeight / 2) {
          // top left
          return {
            class: "m-anchored",
            style: {
              position: "absolute",
              top: `${this.anchorRect.minY}px`,
              left: `${this.anchorRect.maxX + 5}px`,
            },
          };
        } else {
          // bottom left
          return {
            class: "m-anchored",
            style: {
              position: "absolute",
              bottom: `${document.body.clientHeight - this.anchorRect.maxY}px`,
              left: `${this.anchorRect.maxX + 5}px`,
            },
          };
        }
      case "topAuto":
        if (this.anchorRect.minX < document.body.clientWidth / 2) {
          // top left
          return {
            class: "m-anchored",
            style: {
              position: "absolute",
              top: `${this.anchorRect.maxY + 5}px`,
              left: `${this.anchorRect.minX}px`,
            },
          };
        } else {
          // top right
          return {
            class: "m-anchored",
            style: {
              position: "absolute",
              top: `${this.anchorRect.maxY + 5}px`,
              right: `${document.body.clientWidth - this.anchorRect.maxX}px`,
            },
          };
        }
      default:
        return DEFAULT_ANCHOR_INFO;
    }
  }

  onCancel() {
    if (this.mayCancel) {
      this.$emit("cancel");
    }
  }
}
</script>

<style scoped lang="scss"></style>
